import React from 'react'
import styled from 'styled-components'
import { customFilter } from 'react-bootstrap-table2-filter'
import InventoryHistorySearchBar from './InventoryHistorySearchBar'
import { formatedDate } from '../../utils/formatedDate'
import { colors } from '../../styles/colors'
import i18n from '../../translation/i18n'

const StyledComment = styled.div`
    color: ${colors.gray3};
    padding: 4px;
    box-shadow: rgb(0 0 0 / 20%) 0px 0px 15px;
    font-style: italic;
    background: white;
`

const getPendingDeliveryAmount = (item) => {
  const orderedQuantity = item.orderedQuantity || 0
  const shippedQuantity = item.shippedQuantity || 0
  return orderedQuantity - shippedQuantity
}

export const columns = [
  {
    dataField: 'createdAt',
    text: 'date',
    sort: true,
    formatter: (cell) => <div className='fw-bold'>{formatedDate(cell)}</div>
  },
  {
    dataField: 'article.displayName',
    text: 'articles',
    sort: true,
    filter: customFilter(),
    filterRenderer: (onFilter, column) => <InventoryHistorySearchBar onFilter={onFilter} column={column} />,
    formatter: (cell, row) => <div>{row.article.displayName} {row.article.articleNumber}</div>
  },
  {
    dataField: 'articleVariant.displayName',
    text: 'size',
    sort: true,
    filter: customFilter(),
    filterRenderer: (onFilter, column) => <InventoryHistorySearchBar onFilter={onFilter} column={column} />
  },
  {
    dataField: 'type',
    text: 'type',
    sort: true,
    filter: customFilter(),
    filterRenderer: (onFilter, column) => <InventoryHistorySearchBar onFilter={onFilter} column={column} />,
    formatter: (cell) => <span className='text-uppercase'>{cell}</span>
  },
  {
    dataField: 'quantity',
    text: 'variation',
    sort: true,
    formatter: (cell, row) => (
      <>
        {cell}
        {row.type === 'ordered'
          ? <span className='shipping-sum'>&nbsp;{getPendingDeliveryAmount(row) === 0 ? null : `(${getPendingDeliveryAmount(row)}*)`}</span>
          : null
        }
      </>
    ),
    headerFormatterExtra: () => <div className='pending-delivery-info'>* {i18n.t('inventory:pendingDelivery')}</div>
  },
  {
    dataField: 'comment',
    text: 'comment',
    formatter: (cell) => cell ? <StyledComment>{cell}</StyledComment> : null
  }
]
